// extracted by mini-css-extract-plugin
module.exports = {"container":"tJfAg","divider":"_2NO3Z"};